<template>
  <el-form :ref="thisRef" class="file-details" label-position="left" inline>

    <div v-if="!fileData.url">

      <h4>Please upload a file</h4><br />
      <span v-if="fileData.updated_by">&nbsp;&nbsp;
        <el-button type="text" @click="deleteFile()">
        <i class="fa fa-trash-alt text-danger">&nbsp;</i>Remove Category
      </el-button>
    </span>

      <div v-if="fileData.updated_by">
        Updated by: <b>{{fileData.updated_by}}</b> on <i><b>{{formatDateTime(this.fileData.updated_at)}}</b></i>
      </div>
    </div>

    <div v-else>

      <el-row :gutter="8">
        <el-form>
          <el-col :span="21">
            <text-input style="display: block" label="Category"  v-model="fileData.title" :disabled="!editTitle" />
          </el-col>

          <el-col :span="3">
              <el-button
                v-if="!this.fileData.approved && this.isManager() && this.isTowerCo()"
                type="text"
                plain
                :icon="editTitle ? 'fa fa-check-circle' : 'fa fa-edit'"
                @click="edit"
                :disabled="isViewOnly()">
              </el-button>

              <el-button
                v-if="editTitle"
                  type="text"
                  plain
                  icon="fa fa-times-circle"
                  @click="editTitle = false">
                </el-button>

          </el-col>

          <el-col :span="24">
            <el-form-item label="File name">
              <b>{{fileData.name}}</b> (<i>{{this.formatInteger(fileData.size / 1000)}}k</i>)&nbsp;&nbsp;

              <el-button
                v-if="!fileData.approved && !fileData.downloaded"
                  type="danger"
                  size="small"
                  plain
                  icon="fa fa-trash-alt"
                  @click="remove"
                  :disabled="isViewOnly() || disableForm">
              </el-button>

            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <el-row align="middle">
        <span v-if="!fileData.approved">Approval Status: </span>
        <el-switch v-model="fileData.approved" v-if="(this.isManager() || this.isApprover()) && showSwitch"
        active-color="#13ce66" inactive-color="#E6A23C" @change="approved" :disabled="isViewOnly() || disableForm"></el-switch>

        <b v-if="fileData.approved" class="text-success" ><i class="fa fa-check-circle">&nbsp;</i>Approved</b>
        <span class="text-warning" v-else><i class="fa fa-question-circle">&nbsp;</i>Pending</span>

        <span v-if="fileData.approved"><small>On <b>{{this.formatDateTime(fileData.approved_at)}}</b> by <b>{{fileData.approved_by}}</b></small></span>
      </el-row>

      <b v-if="fileData.approved && formValue.status">{{formValue.status}} - </b>

      <span v-if="!editRemarks && fileData.approved && fileData.remarks"><i class="text-muted">Remarks</i></span>
      <html-input v-if="editRemarks" v-model="fileData.remarks" :disabled="isViewOnly() || disableForm" />

      <el-button v-if="fileData.approved && (this.isManager() || this.isApprover()) && this.isTowerCo()"
       :type="editRemarks ? 'success' : 'text'" plain :icon="editRemarks ? 'fa fa-check-circle' : 'fa fa-edit'"
        @click="openRemarks"
        :disabled="isViewOnly() || disableForm">
        {{!fileData.remarks ? 'Edit Remarks' : ''}}
      </el-button>

      <el-button v-if="editRemarks" :type="editRemarks ? 'info' : 'text'" plain icon="fa fa-times-circle"
       @click="editRemarks = false" :disabled="isViewOnly() || disableForm" />
       <div class="html-remarks">
         <p v-if="!editRemarks && fileData.approved" v-html="fileData.remarks"></p>
       </div>

      <el-row v-if="isTowerCo() && !fileData.approved && !disableForm">

        <auto-form
          title="Additional Info"
          :form="formDesc"
          v-model="formValue"
          :save="save"
          :override-span="24"
          :inline="true"
          label-pos="left"
          :disabled="fileData.approved || isViewOnly() || disableForm" />

      </el-row>

      <el-row v-else>

        <el-col v-if="isTowerCo() && fileData.depost > 0 || fileData.ref" :span="24">
           <el-col v-if="fileData.deposit" :span="24">
             Deposit: <b>{{formatNumber(fileData.deposit)}}</b>
           </el-col>

           <el-col v-if="fileData.ref" :span="24">
             Ref: <b>{{fileData.ref}}</b>
           </el-col>

           </el-col>
        </el-col>
      </el-row>

      <el-row>
        <div v-if="rowData.mimeType.endsWith('pdf')">
          <pdf-viewer :url="getEndpoint('/file/view/' + fileData.url)" />
        </div>

        <div v-else>
          <img style="width: 100%;" :src="getEndpoint('/file/view/' + fileData.url)" />
        </div>
      </el-row>

      <el-row align="middle">
        <el-col :span="12">
          <small>Uploaded: <b>{{this.fileData.upload_by}}</b> at <b>{{this.formatDateTime(this.fileData.upload_at)}}</b></small>
        </el-col>

        <el-col :span="12" align="right">
          <small v-if="fileData.downloaded"><small>Last Download: On <b>{{this.formatDateTime(fileData.lastDownload_at)}}</b> by <b>{{fileData.lastDownload_by}}</b></small></small>
        </el-col>
      </el-row>
    </div>
  </el-form>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import AutoForm from '@/components/atoms/AutoForm'
import PdfViewer from '@/components/atoms/PdfViewer'

export default {

  mixins: [PostMixins, DateMixins, NumberMixins],

  components: {
    AutoForm,
    PdfViewer
  },

  props: {
    rowData: {
      type: Object
    },

    rowIndex: {
      type: Number
    }

  },

  methods: {
    edit () {
      this.editTitle = !this.editTitle

      if (!this.editTitle) {
        this.save()
      }
    },

    save (data) {
      this.fileData.state = data
      this.saveForm(this, '/file', this.fileData.id, this.fileData, 'File Details', this.saved, this.error, false)
    },

    saved (response) {
      this.$message({message: 'File Details Saved: [OK]', type: 'success'})
    },

    error (response) {
      this.$message({message: 'Unable to save file details: [' + response + ']', type: 'warning'})
      console.error('File State Failed: ', response)
    },

    openRemarks () {
      this.editRemarks = !this.editRemarks

      if (!this.editTitle) {
        this.saveForm(this, '/file', this.fileData.id, this.fileData, 'File Details', null, null, false)
      }
    },

    approved (value) {
      if (value) {
        this.fileData.approved_at = this.formatDateTimeSql(new Date())
        this.fileData.approved_by = this.userName()

        this.saveForm(this, '/file', this.fileData.id, this.fileData, 'File Details', null, null, false)

      } else {
        this.fileData.approved_at = null
        this.fileData.approved_by = null
      }
    },

    deleted (response) {
      this.$parent.hideDetailRow(this.rowData.id)
      this.$parent.refresh()
    },

    remove () {
      this.saveForm(this, '/file/delete', this.fileData.id, this.fileData, this.fileData.name, this.deleted)
    },

    deleteFile () {
      this.deleteItem(this, this.fileData.id, '/files', 'Remove category: "' + this.fileData.title + '"', this.deleted)
    }
  },

  computed: {
    thisRef: function () {
      return 'file-details-' + this.fileData.step + '-' + this.fileData.partyNo
    }
  },

  data () {
    return {
      editTitle: false,
      editRemarks: false,
      showSwitch: this.isTowerCo() && this.clone(!this.rowData.approved),

      fileData: this.rowData,
      disableForm: this.rowData && this.rowData.options ? this.rowData.options.disableForm : false,

      formDesc: {
        inline: true,
        columns: 3,
        labels: 'top',
        disabled: false,

        fields: [
          {type: Array, prop: 'status', list: ['Pending', 'Rejected', 'Condtional', 'Approved'], label: 'Status', required: true},
          {type: Number, prop: 'deposit', decimal: 0, label: 'Security Deposit'},
          {type: String, prop: 'ref', label: 'Ref #'}
        ]

      },

      formValue: this.rowData.state ? this.rowData.state : {
        status: null,
        deposit: 0,
        ref: null
      }
    }
  }
}

</script>

<style scoped>
 .file-details {padding: 1em; background-color: #F2F6FC;}
 a {text-decoration: none;}
</style>



// WEBPACK FOOTER //
// FileDetails.vue?2cd9c6e0